















































































































































import Vue from 'vue';
import CustomerFilterSettings from './CustomerFilterSettings.vue';
import CustomerFilterDisplay from './CustomerFilterDisplay.vue';
import ScheduleMsgPreview from '../../../rule/components/settings/create/ScheduleMsgPreview.vue';
import AdminVerifyBox from '../common/AdminVerifyBox.vue';
import MessageBox from '../common/MessageBox.vue';
import MassSendMsg, {
  MassSendWxText,
  MassSendWxImage,
  MassSendWxNews } from '../../models/MassSendMsg';
import { MASS } from '../../models/Mass';
import moment from 'moment';
import News from '../../models/News';
import Image from '../../models/Image';
import Customer from '../../../customer/models/Customer';
import massVuex from '../../vuex/common';
import customerVuex from '../../../customer/vuex/common';
import commonClient from '../../../common/apis';
import massClient from '../../apis';
import { TaskType } from '../../../common/models/TaskType';
import format from '../../../customer/components/filter/makeCustomerQuery';
import CustomerExpectedCount from '../common/CustomerExpectedCount.vue';
import FormatEmoji from '@/common/utils/FormatEmoji';

interface SelectedNews {
  parentNews: News;
  childNews: News[];
}

export default Vue.extend({
  mixins: [customerVuex, massVuex],
  components: {
    MessageBox,
    CustomerFilterSettings,
    CustomerFilterDisplay,
    AdminVerifyBox,
    ScheduleMsgPreview,
    CustomerExpectedCount,
  },
  data() {
    return {
      backupQuery: null as any,
      exclude: null as any,
      selectAll: 0,
      showMessageBox: false,
      showAdminVerifyBox: false,
      showPreview: false,
      MASS,
      expectCount: 0,
      isTiming: false,
      timingDay: 1,
      timingTime: null,
      scheduleAt: null,
      dayList: [{value: 1, label: '今天'}, {value: 2, label: '明天'}],
    };
  },
  methods: {
    handleTypeChange(mode: number): void {
      switch(mode) {
        case 0:
          break;
        case 1:
          break;
      }
    },
    setExpectCount(expectCount: number) {
      this.expectCount = expectCount;
    },
    changeSendType(isTiming: boolean) {
      this.isTiming = isTiming;
    },
    confirmMassSend() {
      if (this.validate()) {
        this.showAdminVerifyBox = true;
      }
    },
    updateTimingTime(val: string) {
      this.timingTime = val;
    },
    handleExcludeChange(v: any): void {
      this.exclude = v;
    },
    doMassSend(data: any) {
      commonClient.createTask({
        input: {
          MassSend: {
            query: format.mkFilterQueries(this.customerFilter),
            msg: this.buildMsg(this.massSendMsg),
            exclude: this.exclude,
          },
        },
        taskType: TaskType.MassSend,
        expectCount: this.expectCount,
        isTiming: this.isTiming,
        creator: data.openid,
        creatorName: data.name,
        scheduleAt: this.isTiming ? this.scheduleAt.format('YYYY-MM-DD HH:mm:ss') : null,
      }).success((r: any) => {
        this.$Message.success('创建成功');
        this.showAdminVerifyBox = false;
        this.$router.push('/mass/records');
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    buildMsg(msg: MassSendMsg) {
      const sendMsg = JSON.parse(JSON.stringify(msg));
      if (this.massSendMsg.WxText) {
        const text = FormatEmoji.toEmoji(this.massSendMsg.WxText.text);
        sendMsg.WxText.text = text;
      }
      return sendMsg;
    },
    validate() {
      if ((!this.massSendMsg.WxText ||
           !this.massSendMsg.WxText.text ||
           this.massSendMsg.WxText.text === '') &&
          !this.massSendMsg.WxImage &&
          !this.massSendMsg.WxNews) {
        this.$Message.warning('请设置群发内容');
        return false;
      } else {
        if (this.isTiming) {
          if (this.timingTime) {
            let day = null;
            if (this.timingDay === 1) {
              day = moment();
            } else {
              day = moment().add(1, 'days');
            }
            const dayText = day.format('YYYY-MM-DD');
            this.scheduleAt = moment(dayText + ' ' + this.timingTime);
            if (moment().add(5, 'minutes').isAfter(this.scheduleAt)) {
              this.$Message.warning('定时任务至少在当前时间的5分钟后');
              return false;
            } else {
              return true;
            }
          } else {
            this.$Message.warning('请设置发送时间');
            return false;
          }
        } else {
          return true;
        }
      }
    },
    selectText(content: string) {
      const msg: MassSendMsg = {
        WxText: {
          text: content,
        },
      };
      this.commitUpdateMsg(msg);
    },
    selectImage(image: Image) {
      const msg = {
        WxImage: {
          media: image.mediaId,
          src: image.url,
        },
      };
      this.commitUpdateMsg(msg);
    },
    selectNews(news: SelectedNews) {
      const msg: MassSendMsg = {
        WxNews: {
          mediaId: news.parentNews.mediaId,
          onlyFansCanComment: false,
          allowReprint: true,
          isToAll: true,
          openComment: false,
          newsId: news.parentNews.id,
          snapshot: JSON.stringify({}),
        },
      };
      this.commitUpdateMsg(msg);
    },
    updateAllowReprint(value: boolean) {
      const news = this.massSendMsg.WxNews!;
      news.allowReprint = value;
      this.updateWxNews(news);
    },
    updateOpenComment(value: boolean) {
      const news = this.massSendMsg.WxNews!;
      news.openComment = value;
      this.updateWxNews(news);
    },
    updateWxNewsOnlyFans(value: boolean) {
      const news = this.massSendMsg.WxNews!;
      news.onlyFansCanComment = value;
      this.updateWxNews(news);
    },
    updateWxNews(news: MassSendWxNews) {
      this.$store.commit('UPDATE_MASS_SEND_WX_NEWS', news);
    },
    commitUpdateMsg(msg: MassSendMsg) {
      this.$store.commit('UPDATE_MASS_SEND_MSG', msg);
    },
    confirmFilterCustomer() {
      if (this.filterNothing) {
        this.$Message.warning('请设置至少一项筛选条件');
      } else {
        this.showMessageBox = true;
      }
    },
    isFromFilter() {
      const href = window.location.href;
      return href.indexOf('from=filter') !== -1;
    },
    confirm() {
      this.showAdminVerifyBox = false;
      this.showMessageBox = true;
    },
    doPreview(customer: Customer) {
      massClient.previewMsg({
        openid: customer.openid,
        msg: this.massSendMsg,
      }).success(() => {
        this.$Message.success('发送预览成功，请在手机端查收');
        this.showPreview = false;
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
        this.showPreview = false;
      }).error((e) => {
        this.$Message.error(e.toString());
        this.showPreview = false;
      });
    },
    backToFilter() {
      window.location.href = '#/customer/filter?back=true';
    },
    doShowPreview() {
      if (this.validate()) {
        this.showPreview = true;
      }
    },
  },
  mounted() {
    if (this.isFromFilter()) {
      this.showMessageBox = true;
      this.selectAll = this.filterNothing ? 1 : 0;
    }
  },
});
